Vendd.Scripts.load(function () {
    var $wrapper = $('.x-subcategories-list');

    if ($wrapper.length < 1)
        return;


    var ww = $(window).width();
    var mobile = (ww < 960) ? true : false;

    if (!mobile) {
        initOwlSlider($('.x-subcategories-list .x-categories-slider .x-categories-list > ul'), { items: 9, itemsDesktop: [1600, 7], itemsDesktopSmall: [1400, 6], itemsDesktopTablet: [1199, 5],   itemsMobile: [479, 4], responsiveClass:true });
    } 

    $(window).on('resize', function () {

        ww = $(window).width();
        mobile = (ww < 960) ? true : false;

        if (!mobile) {
            initOwlSlider($('.x-subcategories-list .x-categories-slider .x-categories-list > ul'), { items: 9, itemsDesktop: [1600, 7], itemsDesktopSmall: [1400, 6], itemsDesktopTablet: [1199, 5], itemsMobile: [479, 4], responsiveClass: true });
        } else {
            destroyOwlSlider($('.x-subcategories-list .x-categories-slider .x-categories-list > ul'));
        }

    });
});